<template>
  <div id="forums">
    <div class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
    <div class="container-fluid"  v-if="data.length">
      <div class="cust-head" style="text-align: right;margin-top:10px">
        <h3 style="float:left">Forums</h3>
        <span style="display:inline-block">
          <select @change="refresh"  v-model="selectedProduct" class="form-control text-uppercase">
            <option v-for="d in forumProductsOptions" :value="d.product_name">{{ d.product_name }}</option>
          </select>
        </span>
      </div>
      <b-row>
        <b-col sm="3" lg="3" v-for="d in data" :key="d.website_name">
          <b-card>
            <div class="site-title">
                 <a :href="d.website_url" target="_blank">{{ d.website_name }}</a>
            </div>
            <b-row>
              <b-col sm="12" lg="12" style="padding-bottom: 2px;">
                <b-card style="border: 1px solid #a8dea8;margin-bottom:0">
                  <div class="good-color titles">Good</div>
                  <div class="good-points">
                    <ul>
                      <li v-for="gpt in d.positive_points" > {{ gpt }} </li>
                    </ul>
                  </div>
                </b-card>  
              </b-col>
              <b-col sm="12" lg="12" style="padding-top: 2px;">
                <b-card style="border: 1px solid #ff8686;margin-bottom:0">
                  <div class="bad-color titles">Bad</div>
                  <div class="bad-points">
                    <ul>
                      <li v-for="gpt in d.negative_points" > {{ gpt }} </li>
                    </ul>
                  </div>
                </b-card>  
              </b-col>
            </b-row>
            <div class="view-more" @click="viewMore(d.website_name)">
               View More
            </div>
          </b-card>
        </b-col>
      </b-row>            
    </div>
    <b-modal size="lg" :title="modalTitle" v-model="showModal" >
      <div class="customdim" v-show="modalLoader">
        <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
      </div>
      <b-row>
        <b-col sm="6" lg="6">
          <h5 class="cust-head">Positive</h5>
          <b-card style="border:1px solid #a8dea8">
            <highcharts  :options="wordcloudData.positive" v-if="wordcloudData.positive" ></highcharts>
          </b-card>  
        </b-col>
        <b-col sm="6" lg="6">
          <h5 class="cust-head">Negative</h5>
          <b-card style="border:1px solid #ff8686">
            <highcharts :options="wordcloudData.negative" v-if="wordcloudData.negative" ></highcharts>
          </b-card> 
        </b-col>  
      </b-row>  
    </b-modal>
  </div>
</template>

<script> 
import moment from 'moment'
import datecomponent from './date.vue'

export default {
  name: 'forums',
  components: {
    datecomponent
  },
  data: function () {
    return {
      data: [],
      moment:moment,
      modalData: {},
      showModal: false,
      modalLoader: false,
      modalTitle: '',
      loader: false,
      wordcloudData:{
        positive: {},
        negative: {}
      },
      forumProductsOptions: [],
      selectedProduct: '',
    }
  },
  mounted()
  {
    this.forumProductsOptions = JSON.parse(localStorage.reviewCustomData).forumProducts
    this.selectedProduct = this.forumProductsOptions[0].product_name
    this.refresh()
  },
  methods: {
    plotWordCloud(type,data,min,max){
      this.wordcloudData[type] = {}
      this.$nextTick(function(){
        this.wordcloudData[type] = {
          chart:{
            height:180,
          },
          credits:{
            enabled:false
          },
          series: [{
            type: 'wordcloud',
            data: data,
            name: 'Frequency',
            rotation: {
              from: 0,
              to: 0,
              orientations: 1
            },
            minFontSize: min,
            maxFontSize: max
          }],
          title: {
            text: ''
          }
        }
      })
    },
    viewMore(site){
      this.showModal = true 
      this.modalTitle = "'" + this.selectedProduct + "' on '" + site + "'"
      this.modalLoader = true
      let url = "/api/reviews/websitesent?product_name=" + this.selectedProduct + "&website_name=" + site
      this.$http.get(url).then(response => {
        this.modalData = response.data.data 
        this.modalLoader = false
        let types = {positive:{min:12,max:35},negative:{min:4,max:8}} 
        for (const [i,t] of Object.entries(types))
        {
          let data = []
          for (const [idx,d] of this.modalData[i].entries())
          {
            let obj = {}
            obj.name = d.word
            obj.weight = d.frequency
            obj.Display = d.display
            obj.score = this.$options.filters.format(d.compound_score)
            data.push(obj)
          }
          this.plotWordCloud(i,data,t.min,t.max)
        }
      }, err => {
        this.modalLoader = false
        console.log('error')
      });

    },
    refresh(){
      this.data = []
      this.loader = true
      let url = "/api/reviews/websitedata?product_name=" + this.selectedProduct
      this.$http.get(url).then(response => {
        this.data = response.data.data  
        this.loader = false
        console.log(this.data) 
      }, err => {
        this.loader = false
        console.log('error')
      });
    },
  }
}
</script>
<style scoped>
.site-title
{
  text-align: center;
  border-bottom: 1px solid #d6d6d6;
  text-transform: capitalize;
  margin-bottom: 10px;
  font-size: 17px;

}
.titles
{
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: center;
}
.good-color
{
  background: #a8dea8;
}
.bad-color
{
  background: #ff8686;
}

.bad-points, .good-points
{
    height: 95px;
    overflow-y: auto;
    padding-top: 8px;
}
.view-more
{
  padding: 5px;
  background: whitesmoke;
  margin-top: 9px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
}
.col-sm-6 .card-body, .col-lg-6 .card-body
{
  padding:0!important;
}
.card
{
  border:none;
}
.card ul
{
  padding-left:16px;
  margin-bottom:0!important;
}
</style>